module.exports = __webpack_public_path__ + "static/media/recommendation-related-items.2e3061a3.png";